// Mirror DAY_PARTS in src/pages/edit-quotations|edit-orders/Constants.js
const USER_TIMING_QUICK_ADD_KEYS = ['BREAKFAST', 'LUNCH', 'SNACK', 'DINNER', 'CUSTOM'];

/** How many quick-add slots exist on the user timing profile (same keys as DAY_PARTS). */
export function countUserPreferredTimingSlots(userTimings) {
    if (!userTimings || typeof userTimings !== 'object') return 0;
    let n = 0;
    for (const key of USER_TIMING_QUICK_ADD_KEYS) {
        if (!Object.prototype.hasOwnProperty.call(userTimings, key)) continue;
        if (key === 'CUSTOM') {
            const arr = userTimings[key];
            if (Array.isArray(arr)) n += arr.filter((t) => t != null && t !== '').length;
        } else if (userTimings[key] != null && userTimings[key] !== '') {
            n += 1;
        }
    }
    return n;
}
